import RampPlansNew from "../../RampPlans/RampList/RampsNew/RampPlansNew";

export const RampsListTab = (props) => <RampPlansNew {...props} />;
